import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Full-height centered spinner.
 *
 * Shared between the route-level <Suspense> fallback (while a lazy page chunk
 * loads) and the auth guards (while the session check resolves). Using the same
 * visual in both places means the first paint of a protected URL shows a single
 * continuous spinner instead of two different loading states.
 */
export default function PageLoader() {
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}
    >
      <CircularProgress size={36} />
    </Box>
  );
}
